import { ChangeDetectorRef, Component, Input, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { PredialUrbanoService } from 'src/app/Sercivios/predial-urbano.service';
import { environment } from 'src/environments/environment';
import { RegistrosConsultasService } from 'src/app/Sercivios/registros-consultas.service';
import { RegistrosConsulta } from 'src/app/Entidades/registros_consultas';
import { formatDate } from '@angular/common';
import { PrePagoenlinea } from 'src/app/Entidades/pre-pagoenlinea/pre-pagoenlinea.module';
import CryptoJS from 'crypto-js';
import { HttpErrorResponse } from '@angular/common/http';
import { ToastService } from 'src/app/Sercivios/toast.service';


declare var $: any;

@Component({
  selector: 'app-adeudo',
  templateUrl: './adeudo.component.html',
  styleUrls: ['./adeudo.component.scss']
})
export class AdeudoComponent implements OnInit {

  @ViewChild('formulario') formulario;
  @ViewChild('formulariobanorte') formulariobanorte;
  @ViewChild('formulariobajio') formulariobajio;

  constructor(
    private route: ActivatedRoute,
    private predialurbanoservice: PredialUrbanoService,
    private router: Router,
    private activated_router: ActivatedRoute,
    private registros_consulta: RegistrosConsultasService,
    private toastService: ToastService) { }

  recalculando = false;
  cargando = false;
  adeudo: any = null;
  municipio = "";
  referencia_pago = "";
  generated_signature = "";
  cve_cast = "";
  url_api = "";
  id_express = environment.id_express;
  llave = environment.llave;
  environment_ = environment
  modal_correo = false;
  @Input() valida_pago = false;
  form_tarjeta = true;

  popupTimer: any

  totalstring: string;

  prepago_banorte: any = {}
  visa_mastercard: any = ""

  prepago_tarjeta: any = {}

  descuento_insen: boolean = false;
  cobro_cruzroja: boolean = false;
  cobro_bomberos: boolean = false;

  consulta_registro: RegistrosConsulta = {
    id: "",
    Cve_Catastral: "",
    Nombre_Propietario: "",
    RFC: "",
    Domicilio_Propiedad: "",
    Poblacion_Propiedad: "",
    Ubicacion_Propiedad: "",
    Colonia_Propiedad: "",
    Tipo_Subsidio: "",
    Observaciones: "",
    Periodo: "",
    Periodos: [],
    Principales: [],
    ACOs: [],
    Asistencias_Sociales: [],
    Subcidios: [],
    Recargos: [],
    Multas: [],
    Totales: [],
    Superficie_Terreno: 0,
    Superficie_Construccion: 0,
    Valor_Terreno: 0,
    Valor_Construccion: 0,
    Valor_Catastral: 0,
    Honorarios: 0,
    GastosEjecRequerimiento: 0,
    GastosEjecEmbargo: 0,
    GastosExtCobranza: 0,
    Total: 0,
    Redondeo: 0,
    Fecha: "",
    Municipio: "",
    Cruz_Roja: 0
  };

  ngOnInit(): void {
    let año = new Date().getFullYear().toString();
    this.municipio = environment.municipio
    this.url_api = environment.url_webapi;
    this.route.params.subscribe(params => {
      this.cve_cast = params.cve_catast.match(/\d{3}(?=\d{2,3})|\d+/g).join("-")
      this.predialurbanoservice.GetCalcula_PU(params.cve_catast, año, "4").subscribe(data => {
        if (data.Total != 0) {
          data.Detalle.map(res => {
            res.check = true;
            res.pp = res.prontopago
          });
          this.adeudo = data;
          console.log(this.adeudo)
          this.descuento_insen = this.adeudo.insen > 0;
          this.cobro_cruzroja = this.adeudo.ImporteCruzRoja > 0;
          this.cobro_bomberos = this.adeudo.ImporteBomberos > 0;
          this.consulta_registro.Cve_Catastral = this.adeudo.Cve_Catastral;
          this.consulta_registro.Periodo = this.adeudo.Detalle[this.adeudo.Detalle.length - 1].anio + " - " + this.adeudo.Detalle[this.adeudo.Detalle.length - 1].trimestre;
          this.consulta_registro.Nombre_Propietario = this.adeudo.Nombre_Propietario;
          this.consulta_registro.Total = this.adeudo.Total;
          this.consulta_registro.Fecha = formatDate(new Date(), 'yyyy-MM-dd', 'en_US');
          this.consulta_registro.RFC = this.adeudo.RFC;
          this.consulta_registro.Ubicacion_Propiedad = this.adeudo.Ubicacion_Propiedad;
          this.consulta_registro.Domicilio_Propiedad = this.adeudo.Domicilio_Propiedad;
          this.consulta_registro.Colonia_Propiedad = this.adeudo.Colonia_Propiedad;
          this.consulta_registro.Municipio = this.municipio;
          this.consulta_registro.Poblacion_Propiedad = this.adeudo.Poblacion_Propiedad;
          this.consulta_registro.Valor_Catastral = this.adeudo.Valor_Catastral;
          this.consulta_registro.Superficie_Terreno = this.adeudo.Superficie_Terreno;
          this.consulta_registro.Superficie_Construccion = this.adeudo.Superficie_Construccion;
          this.consulta_registro.Tipo_Subsidio = this.adeudo.Tipo_Subsidio;

          for (var item of this.adeudo.Detalle) {
            this.consulta_registro.Periodos.push(item.anio + " - " + item.trimestre);
            this.consulta_registro.Principales.push(item.principal);
            this.consulta_registro.ACOs.push(item.actualizacion);
            this.consulta_registro.Asistencias_Sociales.push(item.asistencia_social);
            this.consulta_registro.Subcidios.push(item.descuento);
            this.consulta_registro.Recargos.push(item.recargos);
            this.consulta_registro.Multas.push(item.multas);
            this.consulta_registro.Totales.push(item.total)
          }

          this.consulta_registro.Honorarios = this.adeudo.Honorarios;
          this.consulta_registro.GastosEjecRequerimiento = this.adeudo.Honorarios;
          this.consulta_registro.GastosEjecEmbargo = this.adeudo.GastosEjecEmbargo;
          this.consulta_registro.GastosExtCobranza = this.adeudo.GastosExtCobranza;
          this.consulta_registro.Cruz_Roja = 0;
          this.consulta_registro.Total = this.adeudo.Total;
          this.totalstring = this.adeudo.Total.toString();

          this.referencia_pago = this.adeudo.Cve_Catastral.slice(3, 18) + this.adeudo.Desde + this.adeudo.Detalle[this.adeudo.Detalle.length - 1].anio + this.adeudo.Detalle[this.adeudo.Detalle.length - 1].trimestre;

          this.generated_signature = CryptoJS.HmacSHA256(this.referencia_pago + this.totalstring + this.id_express, this.llave).toString(CryptoJS.enc.Hex);

        } else {
          this.adeudo = data;
        }
      }, (error: HttpErrorResponse) => {
        console.log(error)
        alert("Error al conectar con el servidor.");
      });
    });
  }

  // Movil: desglose abierto por indice de periodo.
  desglose_abierto: { [indice: number]: boolean } = {};

  ToggleDesglose(indice: number) {
    this.desglose_abierto[indice] = !this.desglose_abierto[indice];
  }

  // Periodos incluidos en el pago (el primero siempre va incluido).
  get periodosSeleccionados(): number {
    if (!this.adeudo || !this.adeudo.Detalle) { return 0; }
    return this.adeudo.Detalle.filter((d, i) => i === 0 || d.check).length;
  }

  // Ultimo periodo incluido, p. ej. "2026 T4".
  get periodoHasta(): string {
    if (!this.adeudo || !this.adeudo.Detalle || !this.adeudo.Detalle.length) { return ''; }
    let ultimo = this.adeudo.Detalle[0];
    this.adeudo.Detalle.forEach((d, i) => { if (i === 0 || d.check) { ultimo = d; } });
    return ultimo.anio + ' T' + ultimo.trimestre;
  }

  CambioCheck(valorcheck: boolean, indice: number) {
    let index = 0;
    if (valorcheck) {
      index = indice - 1;
      for (var i = indice; i < this.adeudo.Detalle.length; i++) {
        this.adeudo.Detalle[i].check = false
        this.adeudo.Detalle[i].total = this.adeudo.Detalle[i].total - this.adeudo.Detalle[i].prontopago
        this.adeudo.Detalle[i].prontopago = 0;
      }
    } else {
      index = indice;
      for (var i = indice; i >= 0; i--) {
        this.adeudo.Detalle[i].check = true
        if (i != 0) {
          this.adeudo.Detalle[i].prontopago = this.adeudo.Detalle[i].pp;
          this.adeudo.Detalle[i].total = this.adeudo.Detalle[i].total + this.adeudo.Detalle[i].prontopago
        }
      }
    }


    this.recalculando = true;
    this.predialurbanoservice.GetCalcula_PU(this.adeudo.Cve_Catastral, this.adeudo.Detalle[index].anio, this.adeudo.Detalle[index].trimestre).subscribe(data => {
      this.adeudo.Total = data.Total;
      this.adeudo.Redondeo = data.Redondeo;
      this.adeudo.Honorarios_Notificacion = data.Honorarios_Notificacion;
      this.adeudo.GastosEjecRequerimiento = data.GastosEjecRequerimiento;
      this.adeudo.GastosEjecEmbargo = data.GastosEjecEmbargo;
      this.adeudo.GastosExtCobranza = data.GastosExtCobranza;
      this.adeudo.ImporteCruzRoja = data.ImporteCruzRoja;
      this.adeudo.ImporteBomberos = data.ImporteBomberos;
      this.adeudo.insen = data.insen;

      this.descuento_insen = this.adeudo.insen > 0;
      this.cobro_cruzroja = this.adeudo.ImporteCruzRoja > 0;
      this.cobro_bomberos = this.adeudo.ImporteBomberos > 0;

      this.recalculando = false;

      this.totalstring = this.adeudo.Total.toString();

      this.referencia_pago = this.adeudo.Cve_Catastral.slice(3, 18) + this.adeudo.Desde + this.adeudo.Detalle[index].anio + this.adeudo.Detalle[index].trimestre;

      this.generated_signature = CryptoJS.HmacSHA256(this.referencia_pago + this.totalstring + this.id_express, this.llave).toString(CryptoJS.enc.Hex);
    }, (error: HttpErrorResponse) => {
      alert("Error al conectar con el servidor.");
    });
  }

  Preelaborado() {
    let navigationExtras: NavigationExtras = {
      queryParams: {
        valor: JSON.stringify(this.adeudo)
      }
    }
    this.router.navigate(["Preelaborado"], navigationExtras);
  }

  Regresar() {
    this.router.navigate([""]);
  }

  ValidarSubmit() {
    // var x = 1;
    var anio_hasta;
    var trimestre_hasta;
    for (var item of this.adeudo.Detalle) {
      if (item.check) {
        anio_hasta = item.anio
        trimestre_hasta = item.trimestre
      }
    }

    var pre_pago: PrePagoenlinea = {
      id: null,
      referencia: this.referencia_pago,
      clave_catastral: this.adeudo.Cve_Catastral,
      desde: this.adeudo.Desde,
      hasta: anio_hasta + "" + trimestre_hasta,
      importe: this.adeudo.Total,
      redondeo: this.adeudo.Redondeo
    }
    if (environment.banorte != true) {
      this.predialurbanoservice.PrePagoEnLinea(pre_pago).subscribe(data => {
        this.formulario.nativeElement.submit()
      }, (error: HttpErrorResponse) => {
        alert(error.error)
      });
    } else {
      this.form_tarjeta = false;
    }
  }

  ValidarSubmitRosario() {
    // var x = 1;
    var anio_hasta;
    var trimestre_hasta;
    for (var item of this.adeudo.Detalle) {
      if (item.check) {
        anio_hasta = item.anio
        trimestre_hasta = item.trimestre
      }
    }

    var pre_pago: PrePagoenlinea = {
      id: null,
      referencia: this.referencia_pago,
      clave_catastral: this.adeudo.Cve_Catastral,
      desde: this.adeudo.Desde,
      hasta: anio_hasta + "" + trimestre_hasta,
      importe: this.adeudo.Total,
      redondeo: this.adeudo.Redondeo
    }
    if (environment.banorte != true) {
      this.predialurbanoservice.PrePagoEnLinea(pre_pago).subscribe(data => {
        this.formulario.nativeElement.submit()
      }, (error: HttpErrorResponse) => {
        alert(error.error)
      });
    } else {
      this.form_tarjeta = false;
    }
  }

  ValidarSubmitBanorte() {
    // var x = 1;

    var anio_hasta;
    var trimestre_hasta;
    for (var item of this.adeudo.Detalle) {
      if (item.check) {
        anio_hasta = item.anio
        trimestre_hasta = item.trimestre
      }
    }

    this.prepago_tarjeta.referencia = this.referencia_pago
    this.prepago_tarjeta.cve_catast = this.adeudo.Cve_Catastral
    this.prepago_tarjeta.desde = this.adeudo.Detalle[0].anio + " - " + this.adeudo.Detalle[0].trimestre
    this.prepago_tarjeta.hasta = anio_hasta + " - " + trimestre_hasta
    this.prepago_tarjeta.importe = this.adeudo.Total
    this.prepago_tarjeta.redondeo = this.adeudo.Redondeo



    this.prepago_banorte.id_afiliacion = "8224656";
    this.prepago_banorte.numero_tarjeta = this.prepago_tarjeta.numero_tarjeta;
    this.prepago_banorte.fecha_exp = this.prepago_tarjeta.mes + '/' + this.prepago_tarjeta.anio;
    this.prepago_banorte.monto = this.adeudo.Total;
    this.prepago_banorte.marca_tarjeta = "MC"; //validar
    this.prepago_banorte.id_afilacion = "8224656";
    this.prepago_banorte.nombre_comercio = "Municipio de Elota"; //Environment
    this.prepago_banorte.ciudad_comercio = "Elota"; //Municipio
    this.prepago_banorte.url_respuesta = environment.url_webapi + "PagosPredial/PostAcreditacionPagoBanorte";
    this.prepago_banorte.certificacion3d = "03";
    this.prepago_banorte.version3d = "2";
    this.prepago_banorte.tipo_tarjeta = "CR";
    this.prepago_banorte.referencia3d = "888888888888890"; //Formar Referencia
    this.prepago_banorte.pais = "MX";

    this.prepago_banorte.ciudad = this.prepago_tarjeta.ciudad;
    this.prepago_banorte.correo = this.prepago_tarjeta.correo;
    this.prepago_banorte.nombre = this.prepago_tarjeta.nombre;
    this.prepago_banorte.apellido = this.prepago_tarjeta.primer_apellido;
    this.prepago_banorte.codigo_postal = this.prepago_tarjeta.codigo_postal;
    this.prepago_banorte.estado = this.prepago_tarjeta.estado;
    this.prepago_banorte.calle = this.prepago_tarjeta.calle;
    this.prepago_banorte.numero_celular = this.prepago_tarjeta.celular;

    //Guardar prepago
    this.predialurbanoservice.PostGuardarPrepagoBanorte(this.prepago_tarjeta).subscribe(data => {
      setTimeout(() => {
        this.formulariobanorte.nativeElement.submit()
      }, 5000);
    }), (error: any) => {
      console.log("🚀 ~ error:", error)
    }
  }

  CambioCorreo(event) {
    this.predialurbanoservice.PostGuardarPrepagoBanorteByCorreo(event.target.value).subscribe(data => {
      if (data.length != 0) {
        this.prepago_tarjeta = data[0];
      }
    })
  }

  CambiaTarjeta(e) {
    var cadena = (this.prepago_banorte.no_tarjeta).toString()
    if (cadena == 5) {
      this.visa_mastercard = "mastercard"
    } else if (cadena == 4) {
      this.visa_mastercard = "visa"
    }
  }

  ValidarBajio() {
    this.cargando = true;
    this.valida_pago = true;
    const win = window.open('', 'bbjpay', 'width=1500,height=1000,toolbar=no,menubar=no,scrollbars=no,resizable=no,location=no,status=no');
    if (win && win.document.body) {
      win.document.body.innerHTML = '<p style="font-family:sans-serif;text-align:center;margin-top:2rem;">Generando enlace de pago, espere...</p>';
    }

    var anio_hasta;
    var trimestre_hasta;
    for (var item of this.adeudo.Detalle) {
      if (item.check) {
        anio_hasta = item.anio
        trimestre_hasta = item.trimestre
      }
    }

    let prepago_bajio_genera_url = {
      servicio: environment.servicio,
      concepto: '01',
      folio: '01',
      referencia: this.referencia_pago,
      monto: this.adeudo.Total,
      hash: ''
    }

    let pre_pago: PrePagoenlinea = {
      id: null,
      referencia: this.referencia_pago,
      clave_catastral: this.adeudo.Cve_Catastral,
      desde: this.adeudo.Desde,
      hasta: anio_hasta + "" + trimestre_hasta,
      importe: this.adeudo.Total,
      redondeo: this.adeudo.Redondeo
    }

    this.predialurbanoservice.PostGuardarPrepagobajio(pre_pago).subscribe(data => {
      setTimeout(() => {
        this.predialurbanoservice.PostSolicitarPaginaBajioPago(prepago_bajio_genera_url).subscribe(data => {
          this.cargando = false;
          this.PagarConBanBajio(data, this.referencia_pago, win);
        }, (error: HttpErrorResponse) => {
          if (win) { win.close(); }
          this.cargando = false;
          alert(error.error)
        })
      }, 5000);

    }, (error: HttpErrorResponse) => {
      if (win) { win.close(); }
      this.cargando = false;
      alert(error.error)
    })
  }

  // Banco Azteca: se redirige la ventana completa al checkout de DEUNA. Al terminar, DEUNA regresa
  // a /AcreditacionPago (success, error o close) y esa pantalla confirma el estado con el backend.
  PagarConAzteca(bankUrl: string) {
    window.location.href = bankUrl;
  }

  PagarConBanBajio(bankUrl: string, orderId: string, win: Window | null) {
    if (!win || win.closed) {
      window.location.href = bankUrl;
      return;
    }
    win.location.href = bankUrl;
    const maxWaitMs = 15 * 60 * 1000;
    const start = Date.now();
    this.popupTimer = setInterval(async () => {
      if (Date.now() - start > maxWaitMs) {
        clearInterval(this.popupTimer);
        return;
      }
      if (win.closed) {
        this.cargando = true;
        clearInterval(this.popupTimer);
        console.log('La ventana emergente se ha cerrado');
        // En vez de esperar 30s fijos, sondeamos la verificacion hasta que el banco
        // confirme (verificado == true) y avanzamos en cuanto responde.
        this.SondearVerificacion();
      }
    }, 800);
  }

  // Sondeo (polling) de la verificacion del pago con el banco.
  private readonly VERIF_INTERVALO_MS = 2000;      // cada cuanto reintenta la verificacion
  private readonly VERIF_ESPERA_INICIAL_MS = 2000; // espera antes del primer intento
  private readonly VERIF_MAX_MS = 60000;           // tope maximo total de espera

  SondearVerificacion() {
    const inicio = Date.now();

    const intentar = () => {
      this.predialurbanoservice.GetReciboVerificacion(this.referencia_pago).subscribe(data => {
        console.log(data);
        // El banco ya confirmo el pago -> avanzamos de inmediato.
        if (data && data.verificado != null && data.verificado) {
          this.cargando = false;
          window.location.href = environment.url_sitio + "/AcreditacionPago/0/" + this.referencia_pago + "/0";
          return;
        }
        // Aun no confirma: reintenta o agota el tope maximo.
        this.reprogramarVerificacion(inicio, intentar);
      },
        (error: HttpErrorResponse) => {
          console.log("🚀 ~ error:", error);
          // Error transitorio (aun no se registra el pago): seguimos sondeando hasta el tope.
          this.reprogramarVerificacion(inicio, intentar);
        });
    };

    this.popupTimer = setTimeout(intentar, this.VERIF_ESPERA_INICIAL_MS);
  }

  private reprogramarVerificacion(inicio: number, intentar: () => void) {
    if (Date.now() - inicio >= this.VERIF_MAX_MS) {
      // Se agoto el tiempo de espera sin confirmacion del banco.
      this.cargando = false;
      this.toastService.showError('Pago sin verificar.');
      return;
    }
    this.popupTimer = setTimeout(intentar, this.VERIF_INTERVALO_MS);
  }

  ValidarAzteca() {
    this.cargando = true;
    var anio_hasta;
    var trimestre_hasta;
    for (var item of this.adeudo.Detalle) {
      if (item.check) {
        anio_hasta = item.anio
        trimestre_hasta = item.trimestre
      }
    }

    // Montos en centavos (unidad menor de MXN). El backend los recalcula; aqui son informativos.
    const centavos = Math.round(Number(this.adeudo.Total) * 100);
    // Cualquier salida del checkout regresa a la acreditacion, que consulta el estado real.
    const url_regreso = environment.url_sitio + "/AcreditacionPago/0/" + this.referencia_pago + "/0";

    let order: any = {
      "order_type": "PAYMENT_LINK",
      "payer_info": {
        "email": ""
      },
      "order": {
        "order_id": this.referencia_pago, // el backend le agrega un sufijo unico por intento
        "currency": "MXN",
        "items_total_amount": centavos,
        "sub_total": centavos,
        "total_amount": centavos,
        "store_code": "all",
        "payer_info": {
          "email": ""
        },
        "billing_address": {
          "country": "MX",
          "country_code": "MX",
          "email": ""
        },
        "items": [
          {
            "id": this.referencia_pago,
            "name": "Pago Predial",
            "description": "Predio",
            "type": "virtual",
            "total_amount": { "amount": centavos, "currency": "MXN" },
            "unit_price": { "amount": centavos, "currency": "MXN" },
            "quantity": 1,
            "category": "services"
          }
        ],
        "webhook_urls": {
          "notify_order": environment.url_webapi + "PagosPredial/PostAcreditacionPagoBancoAzteca"
        },
        "redirect_urls": {
          "success": url_regreso,
          "error": url_regreso,
          "close": url_regreso
        }
      }
    };

    let pre_pago: any = {
      id: null,
      referencia: this.referencia_pago,
      clave_catastral: this.adeudo.Cve_Catastral,
      desde: this.adeudo.Desde,
      hasta: anio_hasta + "" + trimestre_hasta,
      importe: this.adeudo.Total,
      redondeo: this.adeudo.Redondeo
    };

    let order_prepago: any = { pre_pago: pre_pago, order: order };

    // 1) Si hay una orden viva para esta referencia e importe, se reutiliza su enlace.
    this.predialurbanoservice.GetGetOrderByAzteca(order_prepago).subscribe(data => {
      const existente = this.LeerOrdenAzteca(data);
      if (existente && existente.order) {
        const estado_pago = existente.order.payment && existente.order.payment.data ? existente.order.payment.data.status : '';
        // Ya estaba pagada: se va directo a la acreditacion.
        if (estado_pago === 'processed') {
          window.location.href = url_regreso;
          return;
        }
        if (existente.order.payment_link) {
          this.PagarConAzteca(existente.order.payment_link);
          return;
        }
      }

      // 2) No hay orden reutilizable: se crea una nueva.
      this.predialurbanoservice.PostSolicitarPaginaAztecaPago(order_prepago).subscribe(data => {
        const nueva = this.LeerOrdenAzteca(data);
        if (nueva && nueva.order && nueva.order.payment_link) {
          this.PagarConAzteca(nueva.order.payment_link);
          return;
        }
        this.cargando = false;
        this.toastService.showError('No fue posible generar el enlace de pago. Intente de nuevo.');
      }, (error: HttpErrorResponse) => {
        console.error(error);
        this.cargando = false;
        if (error.status === 409) {
          // El backend explica el motivo (el adeudo cambio o el periodo ya fue pagado).
          this.toastService.showError(typeof error.error === 'string' && error.error
            ? error.error : 'Su adeudo cambió. Vuelva a consultar su clave catastral.');
        } else {
          this.toastService.showError('No fue posible generar el enlace de pago. Intente de nuevo.');
        }
      });
    }, (error: HttpErrorResponse) => {
      console.error(error);
      this.cargando = false;
      this.toastService.showError('No fue posible iniciar el pago. Intente de nuevo.');
    });
  }

  // El backend responde la orden de DEUNA como texto JSON, o "" si no hay orden.
  private LeerOrdenAzteca(data: any): any {
    if (!data) { return null; }
    if (typeof data !== 'string') { return data; }
    try {
      return JSON.parse(data);
    } catch {
      return null;
    }
  }


  PagarBanorte() {
    this.prepago_banorte.NUMERO_TARJETA = this.prepago_banorte.no_tarjeta;
    this.prepago_banorte.FECHA_EXP = this.prepago_banorte.mes + '/' + this.prepago_banorte.anio;
    this.prepago_banorte.MONTO = this.adeudo.Total;
    this.prepago_banorte.marca_tarjeta = "MC";
    this.prepago_banorte.id_afilacion = "8224656";
    this.prepago_banorte.nombre_comercio = "Municipio de Elota";
    this.prepago_banorte.cuidad_comercio = "Elota";
    this.prepago_banorte.url_respuesta = environment.url_webapi + "PagosPredial/PostAcreditacionPago";
    this.prepago_banorte.certificacion3d = "03";
    this.prepago_banorte.referencia3d = this.referencia_pago;
    this.prepago_banorte.cuidad = "Elota";
    this.prepago_banorte.pais = "MX";
    this.prepago_banorte.correo = "sergio_0151@hotmail.com";
    this.prepago_banorte.nombre = "SERGIO";
    this.prepago_banorte.apellido = "GASTELUM";
    this.prepago_banorte.codigo_postal = "81040";
    this.prepago_banorte.estado = "SI";
    this.prepago_banorte.version3d = "8224656";
    this.prepago_banorte.numero_celular = "8224656";
    this.prepago_banorte.tipo_tarjeta = "8224656";

    // var prepago = {
    //   NUMERO_TARJETA: this.prepago_banorte.NUMERO_TARJETA,
    //   FECHA_EXP: this.prepago_banorte.FECHA_EXP,
    //   MONTO: this.prepago_banorte.MONTO,
    //   MARCA_TARJETA: this.prepago_banorte.marca_tarjeta
    //   this.prepago_banorte.id_afilacion
    //   this.prepago_banorte.nombre_comercio
    //   this.prepago_banorte.cuidad_comercio
    //   this.prepago_banorte.url_respuesta
    //   this.prepago_banorte.certificacion3d
    //   this.prepago_banorte.referencia3d
    //   this.prepago_banorte.cuidad
    //   this.prepago_banorte.pais
    //   this.prepago_banorte.correo
    //   this.prepago_banorte.nombre
    //   this.prepago_banorte.apellido
    //   this.prepago_banorte.codigo_postal
    //   this.prepago_banorte.estado
    //   this.prepago_banorte.version3d
    //   this.prepago_banorte.numero_celular
    //   this.prepago_banorte.tipo_tarjeta
    // }
    // this.predialurbanoservice.PagoBanorte(this.prepago_banorte).subscribe(data => {
    //   console.log(data);
    // }, (error: HttpErrorResponse) => {
    //   console.log(error)
    // });
  }


  MostrarModal() {
    console.log("Mostrar")
    $('#correo').modal('show')
  }
}
